/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { type ReactNode, useState } from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import { AppLink } from "@ecom/ui/components/AppLink"
import { SocialLinks } from "./SocialLinks"
import { StoreLinks } from "./StoreLinks"

import * as styles from "./newFooter.module.scss"

const defLicenseText = (
  <>
    © 2004-{new Date().getFullYear()}, ПАО «Совкомбанк». Все права защищены. <br />
    Генеральная лицензия Банка России №963 <br className="d-none d-tab-only-block" />
    от 5 декабря 2014 г.
  </>
)

type Props = {
  ligal?: string
  isRedButton?: boolean
  withSocialLinks?: boolean
  withStoreLinks?: boolean
  withFixedButton?: boolean
  orderNum?: string
  variant?: "halvaDlyagamerov" | "seoPromo" | "X5" | "sticker"
  licenseText?: ReactNode
  actionPassport?: ReactNode
  withoutExpandedBtn?: boolean
}

export const Footer = ({
  ligal = "",
  isRedButton,
  withSocialLinks = false,
  withStoreLinks = false,
  withFixedButton = true,
  orderNum,
  variant,
  licenseText = defLicenseText,
  actionPassport,
  withoutExpandedBtn,
}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <footer className={clsx(styles.footer, variant && styles[variant])}>
      <Container>
        <div
          className={clsx(withFixedButton ? styles.wrapperLarge : styles.wrapperSmall)}
          id="footer"
          data-exclude={orderNum}
        >
          {withSocialLinks && <SocialLinks />}
          {ligal && (
            <>
              <div
                className={clsx(
                  styles.text,
                  !expanded && styles.hide,
                  withoutExpandedBtn && styles.withoutExpandedBtn
                )}
                dangerouslySetInnerHTML={{ __html: ligal }}
                id="ligal"
              />
              {!withoutExpandedBtn && (
                <button
                  type="button"
                  onClick={() => setExpanded((prev) => !prev)}
                  className={clsx(styles.button, isRedButton && styles.redButton)}
                >
                  {expanded ? "Скрыть" : "Подробнее"}
                </button>
              )}
            </>
          )}

          <div className={styles.block}>
            <div className={styles.info}>
              {actionPassport && <p className={styles.actionPassport}>{actionPassport}</p>}
              <p className={styles.text}>{licenseText}</p>
              <p className={styles.cookie}>
                Этот сайт использует cookie-файлы для хранения данных.
                <br className="d-none d-md-block" /> Продолжая использование сайта вы соглашаетесь
                с&nbsp;
                <AppLink
                  href="https://scb.ru/about/pages/cookie-policy"
                  className={styles.websitePolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Политикой
                </AppLink>
              </p>
            </div>
            {withStoreLinks && <StoreLinks />}
          </div>
        </div>
      </Container>
    </footer>
  )
}
